import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';

interface SoftwareVersionProps {
    jobData: any;
}

interface VersionItem {
    key: string;
    label: string;
}

const CORE_SOFTWARE: VersionItem[] = [
    { key: 'Main Application Software', label: 'Main Application Software' },
    { key: 'Display Software', label: 'Display Software' },
    { key: 'Pendant Software', label: 'Pendant Software' },
    { key: 'RRUI Software', label: 'RRUI Software' },
];

const POWER_SUPPLY_CONTROLLERS: VersionItem[] = [
    { key: 'Lead Power Supply Controller Software', label: 'Lead Power Supply Controller' },
    { key: 'Trail Power Supply Controller Software', label: 'Trail Power Supply Controller' },
    { key: 'Lead Wire Controller Software', label: 'Lead Wire Controller' },
    { key: 'Trail Wire Controller Software', label: 'Trail Wire Controller' },
];

const TORCH_TRAVEL_CONTROLLERS: VersionItem[] = [
    { key: 'Lead Torch Control Software', label: 'Lead Torch Control' },
    { key: 'Trail Torch Control Software', label: 'Trail Torch Control' },
    { key: 'Travel Controller Software', label: 'Travel Controller' },
];

const SoftwareVersion: React.FC<SoftwareVersionProps> = ({ jobData }) => {
    const softwareVersions = jobData?.parsed_json_data?.['SOFTWARE VERSIONS'] || {};

    const getVersion = (softwareKey: string): string =>
        softwareVersions[softwareKey]?.find((item: any) => item['Version Number'])?.['Version Number'] || '-';

    const getOnlineStatus = (softwareKey: string): string | null =>
        softwareVersions[softwareKey]?.find((item: any) => item['Online Status'])?.['Online Status'] || null;

    const renderStatusBadge = (status: string | null) => {
        if (!status) return null;
        const isOnline = status.toLowerCase() === 'online';
        return (
            <span
                className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${
                    isOnline
                        ? 'text-galvanizing-green bg-[rgba(31,154,58,0.08)]'
                        : 'text-readable-red bg-[rgba(196,0,31,0.06)]'
                }`}
            >
                {status}
            </span>
        );
    };

    const renderField = (item: VersionItem) => (
        <div key={item.key} className="min-w-0">
            <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-1">
                {item.label}
            </div>
            <div className="flex items-center gap-2">
                <span className="text-[13px] font-medium text-text-grey truncate">{getVersion(item.key)}</span>
                {renderStatusBadge(getOnlineStatus(item.key))}
            </div>
        </div>
    );

    const renderSection = (title: string, items: VersionItem[]) => (
        <Card className="bg-white border border-[#E2E5EA] shadow-sm">
            <CardContent className="p-5">
                <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">{title}</h3>
                <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-x-6 gap-y-4">
                    {items.map(renderField)}
                </div>
            </CardContent>
        </Card>
    );

    return (
        <div className="p-6 space-y-4">
            {renderSection('Core Software', CORE_SOFTWARE)}
            {renderSection('Power Supply Controllers', POWER_SUPPLY_CONTROLLERS)}
            {renderSection('Torch & Travel Controllers', TORCH_TRAVEL_CONTROLLERS)}
        </div>
    );
};

export default SoftwareVersion;
